import { ResetPasswordResendOtpNamespace } from '@core/models/client';

export namespace ResetPasswordResendOtpApiNamespace {
  export class IN {
    recoverPasswordKey: string = '';
    recaptchaToken: string = '';
    constructor(input: ResetPasswordResendOtpNamespace.IN) {
      this.recoverPasswordKey = input.requestKey;
      this.recaptchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    message: string = '';
  }
}
